var exports = {
  "Qs": "KeyboardShortcutsCheatsheetModal.module__content___ZF9kS0",
  "V0": "KeyboardShortcutsCheatsheetModal.module__sections___ZF9kS0",
  "uW": "KeyboardShortcutsCheatsheetModal.module__section___ZF9kS0",
  "Gf": "KeyboardShortcutsCheatsheetModal.module__sectionTitle___ZF9kS0",
  "wE": "KeyboardShortcutsCheatsheetModal.module__shortcutRows___ZF9kS0",
  "J8": "KeyboardShortcutsCheatsheetModal.module__shortcutRow___ZF9kS0",
  "hV": "KeyboardShortcutsCheatsheetModal.module__shortcutLabel___ZF9kS0",
  "PU": "KeyboardShortcutsCheatsheetModal.module__chipGroups___ZF9kS0",
  "al": "KeyboardShortcutsCheatsheetModal.module__chipGroup___ZF9kS0",
  "jw": "KeyboardShortcutsCheatsheetModal.module__chip___ZF9kS0",
};

module.exports = exports;
